var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/folio.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/input/InputComponent.scss";
// components
import Errormsg from "@frameworks/web/components/generic/errorMsg";
var FolioSelector = function (_a) {
    var _b;
    var folios = _a.folios, selectedFolio = _a.selectedFolio, onSelect = _a.onSelect;
    var _c = __read(useState(false), 2), open = _c[0], setOpen = _c[1];
    var searchRef = useRef(null);
    var handleSelect = function (folio) {
        onSelect(folio);
        setOpen(false);
    };
    var selecteditem = (_b = folios === null || folios === void 0 ? void 0 : folios.filter(function (item) { return item.number == selectedFolio; })[0]) !== null && _b !== void 0 ? _b : { amount: "", units: "" };
    useEffect(function () {
        function handleClickOutside(event) {
            if (searchRef.current &&
                !searchRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchRef]);
    return (React.createElement("div", { ref: searchRef, className: "ai-container position-relative" },
        React.createElement("label", { className: "ai-label DMSanN_14_400" },
            "Folio ",
            React.createElement("span", { className: "redstar" }, "*")),
        React.createElement("div", { className: "folio-selector" },
            React.createElement("div", { className: "folio-selector__header ".concat(open && "folio-selector__header_open"), onClick: function () { return setOpen(!open); } },
                React.createElement("div", { className: "folio-selector__selected " },
                    React.createElement("p", { className: "txt-midnight-blue DMSanN_14_400" }, selectedFolio || "Select"),
                    open && folios.length > 0 && (React.createElement("div", { className: "d-flex gap-2 align-content-center" },
                        React.createElement("p", { className: "txt-Primary-gray DMSanN_14_400" },
                            "\u20B9",
                            Number(selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.amount).toFixed(2)),
                        React.createElement("div", { className: "units d-flex align-content-center" },
                            React.createElement("span", { className: "txt_black-one1 Roboto_12_400" },
                                "Units: ", selecteditem === null || selecteditem === void 0 ? void 0 :
                                selecteditem.units))))),
                React.createElement("i", { className: "d-flex justify-content-center align-items-center size-16 ".concat(open
                        ? "edel-icon-arrow-up txt-nuvamaBlue"
                        : "edel-icon-arrow-down txt-nuvamaBlue") })),
            open && (React.createElement("div", { className: "folio-selector__list shadow-sm position-absolute" }, folios && folios.length > 0 ? (React.createElement(React.Fragment, null, folios === null || folios === void 0 ? void 0 : folios.map(function (folio) { return (React.createElement("label", { key: folio.number, className: "folio-selector__item ".concat(folio.number === selectedFolio
                    ? "folio-selector__item--active"
                    : "") },
                React.createElement("input", { type: "radio", name: "folio", value: folio.number, checked: folio.number === selectedFolio, onClick: function () { return handleSelect(folio); } }),
                React.createElement("div", null,
                    React.createElement("div", { className: "txt-grey-shade1 DMSanN_14_400 ".concat(folio.number === selectedFolio ? "active" : "") },
                        "Folio no. ",
                        folio.number),
                    React.createElement("div", { className: "d-flex gap-2 align-content-center" },
                        React.createElement("span", { className: "txt-midnight-blue RobotoR_14_400" },
                            "\u20B9",
                            Number(folio.amount).toFixed(2)),
                        React.createElement("div", { className: "units d-flex align-content-center" },
                            React.createElement("span", { className: "txt_black-one1 Roboto_12_400" },
                                "Units: ",
                                folio.units)))))); }))) : (React.createElement(React.Fragment, null,
                React.createElement(Errormsg, { msg: "No Data Found" }))))))));
};
export default FolioSelector;
